import { configureStore } from '@reduxjs/toolkit';
import caseIdFromUrlReducer from '../componentData/caseIdFromUrlSlice';
import loadingReducer from '../loadingSlice';
var store = configureStore({
    reducer: {
        adminData: caseIdFromUrlReducer,
        loadingStore: loadingReducer,
    },
});
export default store;
